const EVENT_FIELDS = ["date", "time", "price", "type", "host", "presented-by", "ticket"];

function readEventMeta(element) {
  const tags = (element.dataset.eventTags || "")
    .split("||")
    .map((tag) => tag.trim())
    .filter(Boolean);

  return tags.reduce((values, tag) => {
    EVENT_FIELDS.forEach((field) => {
      const prefix = `#event-${field}:`;
      if (tag.toLowerCase().startsWith(prefix)) {
        values[field] = tag.slice(prefix.length).trim();
      }
    });
    return values;
  }, {});
}

export default function initEvents(root = document) {
  root.querySelectorAll("[data-event-tags]").forEach((event) => {
    if (event.dataset.eventReady === "true") return;

    const values = readEventMeta(event);
    event.querySelectorAll("[data-event-field]").forEach((field) => {
      const value = values[field.dataset.eventField];
      if (value) field.textContent = value;
    });

    event.querySelectorAll("[data-event-ticket]").forEach((link) => {
      if (values.ticket) link.href = values.ticket;
    });

    event.dataset.eventReady = "true";
  });
}
